/* Fiche bouteille : quantité, fenêtre « jeu en supplément », points de carrousel, apparitions */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  // Apparitions douces au défilement
  var items = document.querySelectorAll('.pf [data-reveal]:not([data-reveal="none"])');
  if ('IntersectionObserver' in window && items.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  } else {
    items.forEach(function (el) { el.classList.add('is-in'); });
  }

  // Points sous les carrousels
  document.querySelectorAll('.pf [data-carousel]').forEach(function (car) {
    var track = car.querySelector('[data-track]');
    var dots = car.querySelector('[data-dots]');
    if (!track || !dots) return;
    var slides = track.querySelectorAll(':scope > li');
    if (slides.length < 2) { dots.hidden = true; return; }
    var max = Math.min(slides.length, 6);
    for (var i = 0; i < max; i++) dots.appendChild(document.createElement('span'));
    var spans = dots.querySelectorAll('span');
    function update() {
      var w = slides[0].getBoundingClientRect().width + 12;
      var idx = Math.round(track.scrollLeft / w);
      var atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
      if (atEnd) idx = slides.length - 1;
      var on = Math.min(max - 1, Math.round(idx * (max - 1) / Math.max(1, slides.length - 1)));
      spans.forEach(function (s, k) { s.classList.toggle('is-on', k === on); });
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    update();
  });

  // Stepper de quantité
  document.querySelectorAll('.pf-qty').forEach(function (box) {
    var input = box.querySelector('[data-qty]');
    var minus = box.querySelector('[data-qty-minus]');
    var plus = box.querySelector('[data-qty-plus]');
    if (!input) return;
    function set(v) { input.value = Math.max(1, Math.min(20, v || 1)); input.dispatchEvent(new Event('change', { bubbles: true })); }
    if (minus) minus.addEventListener('click', function () { set((parseInt(input.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { set((parseInt(input.value, 10) || 1) + 1); });
    input.addEventListener('blur', function () { set(parseInt(input.value, 10)); });
  });

  // Mise à jour de la pastille du panier dans l'en-tête
  function refreshCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var link = document.querySelector('.header__cart');
        if (!link) return;
        var badge = link.querySelector('.header__count');
        if (!badge) { badge = document.createElement('span'); badge.className = 'header__count'; badge.setAttribute('aria-hidden', 'true'); link.appendChild(badge); }
        badge.textContent = cart.item_count;
        badge.animate && badge.animate([{ transform: 'scale(.6)' }, { transform: 'scale(1.25)' }, { transform: 'scale(1)' }], { duration: 450, easing: 'ease-out' });
      }).catch(function () {});
  }

  function addToCart(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || 'Ajout impossible.');
        return data;
      });
    });
  }

  // « Ajouter au panier » → fenêtre de proposition du jeu
  document.querySelectorAll('.pf[data-product]').forEach(function (art) {
    var form = art.querySelector('[data-upsell]');
    var modal = art.querySelector('[data-upsell-modal]');
    if (!form || !modal) return;
    var errorEl = form.querySelector('[data-form-error]');
    var addBtn = form.querySelector('[data-add-button]');
    var modalErr = modal.querySelector('[data-modal-error]');

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var id = parseInt(form.querySelector('[data-variant-id]').value, 10);
      var qty = Math.max(1, parseInt(form.querySelector('[data-qty]').value, 10) || 1);
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      addBtn.disabled = true;
      addToCart([{ id: id, quantity: qty }]).then(function () {
        addBtn.disabled = false;
        refreshCount();
        if (typeof modal.showModal === 'function') {
          if (modalErr) modalErr.hidden = true;
          modal.showModal();
        } else {
          window.location.href = root + 'cart';
        }
      }).catch(function (err) {
        addBtn.disabled = false;
        if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
      });
    });

    var gameBtn = modal.querySelector('[data-upsell-add]');
    if (gameBtn) {
      gameBtn.addEventListener('click', function () {
        var qty = Math.max(1, parseInt(form.querySelector('[data-qty]').value, 10) || 1);
        gameBtn.disabled = true;
        addToCart([{ id: parseInt(gameBtn.getAttribute('data-addon-id'), 10), quantity: qty, properties: { 'Pour la bouteille': art.getAttribute('data-bottle-name') || '' } }]).then(function () {
          window.location.href = root + 'cart';
        }).catch(function (err) {
          gameBtn.disabled = false;
          if (modalErr) { modalErr.textContent = err.message; modalErr.hidden = false; }
        });
      });
    }
    modal.querySelectorAll('[data-modal-close]').forEach(function (b) { b.addEventListener('click', function () { modal.close(); }); });
    modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });
  });
})();

/* Jeux : choix de la ou des bouteilles (une ligne de commande par jeu, avec ses propriétés) */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  document.querySelectorAll('[data-bottle-pick]').forEach(function (box) {
    var form = box.closest('form');
    var list = box.querySelector('[data-pick-list]');
    var qty = form && form.querySelector('[data-qty]');
    var first = list && list.querySelector('.pick__row');
    if (!form || !qty || !first) return;
    var per = parseInt(box.getAttribute('data-per-unit'), 10) || 1;
    var key = box.getAttribute('data-key');
    var model = first.cloneNode(true);
    model.querySelector('select').removeAttribute('name');
    var idInput = form.querySelector('[data-variant-id]');
    var errorEl = form.querySelector('[data-form-error]');
    var addBtn = form.querySelector('[data-add-button]');

    function render() {
      var n = Math.max(1, Math.min(20, parseInt(qty.value, 10) || 1));
      var keep = [].map.call(list.querySelectorAll('select'), function (s) { return s.value; });
      list.innerHTML = '';
      for (var u = 1; u <= n; u++) {
        if (n > 1) { var h = document.createElement('p'); h.className = 'pick__unit'; h.textContent = 'Jeu n°' + u; list.appendChild(h); }
        for (var k = 1; k <= per; k++) {
          var row = model.cloneNode(true);
          row.querySelector('span').textContent = per === 1 ? 'Bouteille' : 'Bouteille ' + k;
          var s = row.querySelector('select'); s.setAttribute('data-unit', u); s.setAttribute('data-k', k);
          var old = keep[(u - 1) * per + (k - 1)]; if (old) s.value = old;
          list.appendChild(row);
        }
      }
    }
    qty.addEventListener('change', render); qty.addEventListener('input', render);
    render();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      box.classList.remove('is-error');
      if (!form.reportValidity()) { box.classList.add('is-error'); return; }
      var n = Math.max(1, parseInt(qty.value, 10) || 1);
      var items = [];
      for (var u = 1; u <= n; u++) {
        var props = {};
        for (var k = 1; k <= per; k++) {
          var s = list.querySelector('select[data-unit="' + u + '"][data-k="' + k + '"]');
          props[per === 1 ? key : key + ' ' + k] = s ? s.value : '';
        }
        items.push({ id: parseInt(idInput.value, 10), quantity: 1, properties: props });
      }
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      addBtn.disabled = true;
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (res) { return res.json().then(function (d) { if (!res.ok) throw new Error(d.description || d.message || 'Ajout impossible.'); return d; }); })
        .then(function () { window.location.href = root + 'cart'; })
        .catch(function (err) { addBtn.disabled = false; if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; } });
    });
  });
})();

/* Zoom : toute image marquée data-zoom s'ouvre en grand (flèches, clavier, balayage) */
(function () {
  'use strict';
  var dlg = document.createElement('dialog');
  dlg.className = 'zoom'; dlg.setAttribute('aria-label', 'Photo agrandie');
  dlg.innerHTML = '<button class="zoom__btn zoom__close" type="button" aria-label="Fermer">×</button><button class="zoom__btn zoom__prev" type="button" aria-label="Photo précédente">‹</button><img class="zoom__img" alt=""><button class="zoom__btn zoom__next" type="button" aria-label="Photo suivante">›</button><p class="zoom__count" aria-live="polite"></p>';
  document.body.appendChild(dlg);
  var img = dlg.querySelector('.zoom__img'), count = dlg.querySelector('.zoom__count');
  var list = [], idx = 0, x0 = null;
  function full(el) { return el.getAttribute('data-full') || el.currentSrc || el.src; }
  function show(i) {
    idx = (i + list.length) % list.length;
    img.src = full(list[idx]); img.alt = list[idx].alt || '';
    count.textContent = list.length > 1 ? (idx + 1) + ' / ' + list.length : '';
    dlg.querySelector('.zoom__prev').hidden = dlg.querySelector('.zoom__next').hidden = list.length < 2;
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-zoom]');
    if (!t || typeof dlg.showModal !== 'function') return;
    var scope = t.closest('[data-carousel], .product__gallery, .pf-wrap') || document;
    list = [].slice.call(scope.querySelectorAll('[data-zoom]')).filter(function (n, k, a) { return a.findIndex(function (m) { return full(m) === full(n); }) === k; });
    var at = list.findIndex(function (n) { return full(n) === full(t); });
    show(at < 0 ? 0 : at); dlg.showModal();
  });
  dlg.querySelector('.zoom__close').addEventListener('click', function () { dlg.close(); });
  dlg.querySelector('.zoom__prev').addEventListener('click', function () { show(idx - 1); });
  dlg.querySelector('.zoom__next').addEventListener('click', function () { show(idx + 1); });
  dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
  dlg.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') show(idx - 1); if (e.key === 'ArrowRight') show(idx + 1); });
  dlg.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
  dlg.addEventListener('touchend', function (e) { if (x0 === null || e.touches.length) return; var d = e.changedTouches[0].clientX - x0; if (Math.abs(d) > 60) show(idx + (d < 0 ? 1 : -1)); x0 = null; });
})();
